export default () => {
  console.log('INIT FEATURES');
  let featureLists = document.querySelectorAll('[feature-list]');
  featureLists.forEach((featureList) => {
    let firstTime = true;
    let isActive = false;
    let autoplay = 0;
    let currentSlide = 0;
    console.log(featureList);
    let features = featureList.querySelectorAll('[feature-card]');
    let removeCurrent = () => {
      let current = featureList.querySelector('[feature-card].active');
      if (current) {
        current.classList.remove('active');
      }
    };
    features.forEach((feature, index) => {
      feature.addEventListener('mouseover', () => {
        removeCurrent();
        isActive = false;
        clearInterval(autoplay);
      });
      feature.addEventListener('mouseout', () => {
        onResize();
      });
    });
    let featureReveal = () => {
      removeCurrent();
      features[currentSlide].classList.add('active');

      currentSlide++;
      if (currentSlide >= features.length) {
        currentSlide = 0;
      }
    };
    let onResize = () => {
      if (window.innerWidth < 980) {
        if (isActive) {
          isActive = false;
          clearInterval(autoplay);
        }
      } else {
        if (!isActive) {
          if (!isActive) {
            isActive = true;
            if (firstTime) {
              featureReveal();
              firstTime = false;
            }
            autoplay = setInterval(featureReveal, 5000);
          }
        }
      }
    };
    window.addEventListener('resize', onResize);
    onResize();
  });
};
